import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './environments/environment-wrapper';

if (environment.production) {
  enableProdMode();

  if (window) {
    window.console.log = function() {};
    window.console.error = function() {};
    window.console.warn = function() {};
    window.console.time = function() {};
    window.console.timeEnd = function() {};
  } else {
    console.log = function() {};
    console.warn = function() {};
    console.time = function() {};
    console.timeEnd = function() {};
  }
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppBrowserModule)
    .then(() => {
      // registerServiceWorker('rmx-v1-sw')
    })
    .catch(err => console.log(err));
});

// function registerServiceWorker(swName: string) {

//   if (environment.sw && navigator && 'serviceWorker' in navigator) {
//       navigator.serviceWorker.register(`/${swName}.js`).then(function(registration) {
//         registration.addEventListener('updatefound', function() {
//           const newWorker = registration.installing;
//           newWorker.addEventListener('statechange', function() {
//             if (newWorker.state === 'redundant') {
//               // When state is redundant it is likely that storage is full. Safest thing to do is unregister SW
//               // and app will fall back to network on next load
//               console.log('Unregistering redundant service worker');
//               registration.unregister();
//             }
//           });
//         });
//       }).catch(err => {
//         console.error('[App] Service worker registration failed', err);
//       });
//   }

// }
